/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ProcessRequirementsSectionTypeDto = {
    NiceToHave: 'NICE_TO_HAVE',
    Required: 'REQUIRED'
} as const;

export type ProcessRequirementsSectionTypeDto = typeof ProcessRequirementsSectionTypeDto[keyof typeof ProcessRequirementsSectionTypeDto];



